import React from 'react'
import { Modal, Button, InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'

const UserModal = ({ show, handleClose, selectedUser }) => {
    const {first_name, last_name, email_adress, password, user_type, user_status, username} = selectedUser;
    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                Détails utilisateur
            </ModalHeader>
            <ModalBody>
                
                <div className="flex flex-col gap-4">
                    <UserProperty property="First Name" value={first_name} />
                    <UserProperty property="Last Name" value={last_name} />
                    <UserProperty property="Email" value={email_adress} />
                    <UserProperty property="Password" type="password" value={"**********"} />
                    <UserProperty property="User type" value={user_type} />
                    <UserProperty property="User status" value={user_status} />
                    <UserProperty property="Username"value={username} />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="light" onClick={handleClose}>
                    Fermer
                </Button>
            </ModalFooter>
        </Modal>
    );
}

const UserProperty = ({ property, value, type }) =>
    <InputGroup>
        <InputGroupAddon addonType="prepend">
            <InputGroupText>{property}</InputGroupText>
        </InputGroupAddon>
        <Input
            readOnly
            type={type || "text"}
            defaultValue={value}
        />
    </InputGroup>

export default UserModal
